import { AccionModal } from './../../models/modal-select.model';
import { Component, Input, ViewEncapsulation, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BaseControl } from '@app/shared/dynamic-form/shared/controls/base-control';
import * as _ from 'lodash';
import { Class } from '@app/shared/dynamic-form/shared/controls/options.model';
import { isFunction } from 'util';
import { GlobalNotifierService } from '@app/core/utilities/global-notifier.service';

@Component({
  selector: 'iw-df-control',
  templateUrl: './dynamic-form-control.component.html',
  styleUrls: ['./dynamic-form-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicFormControlComponent implements AfterViewInit {
  // Referencia al formulario
  @Input() form: FormGroup;
  // Errores de validación
  @Input() formErrors: {};

  @Input()
  set control(value: BaseControl<any>) {
    this._control = value;
    if (this.control.controlType !== 'container') {
      if (typeof this.control.class !== 'string') {
        this.changeRunClass = true;
        this.initCssClass();
      }
      if (this.control.validations.validators.length) {
        for (let i = 0; i < this.control.validations.validators.length; i++) {
          if (this.control.validations.validators[i].toString() === Validators.required.toString()) {
            this.requiered = true;
            break;
          } else {
            this.requiered = false;
          }
        }
      } else {
        this.requiered = false;
      }
    }
  }

  requiered = false;
  // Clases estáticas del contenedor del control
  cssClassContainer = {};
  // Clases estáticas del label
  cssClassLabel = {};
  // Clases estáticas del input
  cssClassInput = {};
  cssClassTextArea = {};

  changeRunClass = false;

  // Campo actual
  private _control: BaseControl<any>;
  // Contiene tiempo de cambios a emitir del formulario
  private t: any;
  // Emite el evento de accion de los modalSelect
  @Output() actionSelector: EventEmitter<AccionModal> = new EventEmitter();
  // Emite el evento de accion de los modalSelect
  @Output() changeInput: EventEmitter<BaseControl<any>> = new EventEmitter();

  constructor(private gns: GlobalNotifierService) {}

  ngAfterViewInit(): void {
    this.gns.listen().subscribe(list => {
      let destiny = '';
      if (this.control.idInput) {
        destiny = this.control.idInput + '-' + this.control.key;
      } else {
        destiny = String(this.control.key);
      }
      if (list.action === 'loadingData' && list.destiny === destiny) {
        if (list.source !== 'multipleProperties') {
          this.control[list.source] = list.data;
          if (this.control.controlType === 'modalSelect' && list.source === 'data') {
            this.control['data'] = list.data;
            this.gns.set<any>({
              source: 'RefactorDynamicFormComponent',
              destiny: 'ModalSelectComponent-' + this.control.key,
              action: 'loadingData',
              eventTriggered: 'click',
              data: <any> list.data
            }, true);
          }
        } else {
          if (typeof list.data === 'object' && Object.keys(list.data).length) {
            Object.keys(list.data).forEach(key => {
              this.control[key] = list.data[key];
              if (this.control.controlType === 'modalSelect' && key === 'data') {
                this.control['data'] = list.data[key];
                this.gns.set<any>({
                  source: 'RefactorDynamicFormComponent',
                  destiny: 'ModalSelectComponent-' + this.control.key,
                  action: 'loadingData',
                  eventTriggered: 'click',
                  data: <any> list.data[key]
                }, true);
              }
            });
          }
        }
        // Eliminar este mensaje
        this.gns.delete(list.index);
      }
    });
  }

  get control(): BaseControl<any> {
    return this._control;
  }

  /**
   * Agrega a los elementos que conforman el control
   * las clases predeterminadas.
   *
   * @private
   * @memberof DynamicFormControlComponent
   */
  private initCssClass() {
    this.form.controls[this.control.key].valueChanges.subscribe(() => {
      // if (!this.changeRunClass && this.control['controlType'] === 'datetimepicker') {
      if (this.control['controlType'] === 'datetimepicker') {
        // Esta subscripcion se comenta debido a que aun no se puede agregar estas clases a los selectores
        // this.changeRunClass = true;
        // this.initCssClass();
          this.cssClassInput['disabled-date-picker'] = this.form.controls[this.control.key].disabled;
      }
    });

    if (this.control.controlType !== 'container') {
      const css = this.control.class as Partial<Class>;
      // INICIALIZAR CLASES ESTÁTICAS
      // Clases estáticas del contenedor del control
      this.cssClassContainer = {
        'm-0': this.control.hidden
      };
      // Clases estáticas del label
      this.cssClassLabel = {};
      // Clases estáticas del input
      this.cssClassInput = {
        'is-invalid': (!_.isEmpty(this.formErrors[this.control.key]) ||
                      this.form.controls[this.control.key].invalid) &&
                      this.form.controls[this.control.key].dirty,
        'is-valid': _.isEmpty(this.formErrors[this.control.key]) &&
                    this.form.controls[this.control.key].valid &&
                    this.form.controls[this.control.key].dirty
      };
      if (this.control.controlType === 'textarea') {
        this.cssClassTextArea = {'n-resize': this.control['notResize']};
        if (this.control['transform']) {
          if (this.control['transform'] === 'uppercase') {
            this.cssClassTextArea['text-uppercase'] = true;
          } else if (this.control['transform'] === 'lowercase') {
            this.cssClassTextArea['text-lowercase'] = true;
          }
        }
      } else {
        if (this.control['transform']) {
          if (this.control['transform'] === 'uppercase') {
            this.cssClassInput['text-uppercase'] = true;
          } else if (this.control['transform'] === 'lowercase') {
            this.cssClassInput['text-lowercase'] = true;
          }
        }
      }
      // INICIALIZAR CLASES POR DEFAULT
      // Agregar clases adicionales para el contenedor del control
      this.cssClassContainer[this.addClassDefault('container', this.control['type'], css.container).join(' ')] = true;
      // Agregar clases adicionales para el label
      this.cssClassLabel[this.addClassDefault('label', this.control['type'], css.label).join(' ')] = true;
      if (this.control['type'] === 'checkbox') {
        this.cssClassLabel['readonly-personalized'] = this.control.readonly;
      }
      // Agregar clases adicionales para el input
      this.cssClassInput[this.addClassDefault('input', this.control['type'], css.input).join(' ')] = true;
      if (this.control['controlType'] === 'datetimepicker') {
        this.cssClassInput['readonly-personalized'] = this.control.readonly;
        this.cssClassInput['disabled-date-picker'] = this.form.controls[this.control.key].disabled;
      }
    }
    this.changeRunClass = false;
  }

  /**
   * Controla que el cambio se emita una vez el usuario deje de escribir en el campo
   *
   * @param {BaseControl<any>} control
   * @memberof DynamicFormControlComponent
   */
  dataChangeInput(control: BaseControl<any>) {
    this.changeInput.emit(control);
  }

  /**
   * Valida si se configuraron clases css para el contenedor,
   * label y input del control, de no ser asi se agregan clases
   * por defecto para que el control tenga una buena apariencia.
   *
   * @private
   * @param {string} elementType - Tipo de elemento: 'container', 'label' y 'input'.
   * @param {string} inputType - Tipo de input estándar de html5.
   * @param {string[]} [cssClassCustom=[]] - Clases personalizadas.
   * @returns {Array<string>} - ['class1', 'class2', 'class3']
   * @memberof DynamicFormControlComponent
   */
  private addClassDefault(elementType: string, inputType: string, cssClassCustom: string[] = []): Array<string> {
    // Si no hay clases css personalizadas para el input
    if (_.isEmpty(cssClassCustom)) {
      let cssClassDefault: Array<string> = [];

      // Tipo de elemento al que se le quiere aplicar clases
      switch (elementType) {
        // Clases para los contenedor
        case 'container':
          switch (inputType) {
            case 'checkbox':
            case 'radio':
              cssClassDefault = ['form-check'];
              break;
            default:
              cssClassDefault = ['form-group'];
              break;
          }
          break;

        // Clases para el label
        case 'label':
          switch (inputType) {
            case 'checkbox':
            case 'radio':
              cssClassDefault = ['form-check-label'];
              break;
            default:
              cssClassDefault = ['col-form-label'];
              break;
          }
          break;

        // Clases para el input
        case 'input':
          switch (inputType) {
            case 'checkbox':
            case 'radio':
              cssClassDefault = ['form-check-input'];
              break;
            case 'file':
              cssClassDefault = ['form-control-file'];
              break;
            default:
              cssClassDefault = ['form-control'];
              break;
          }
          break;
      }
      // Clases por defaul
      return cssClassDefault;
    } else {
      // Clases personalizadas
      return cssClassCustom;
    }
  }

  /**
   * Limpia el campo dentro del formulario indicado
   *
   * @param {string} nameField
   * @memberof DynamicFormControlComponent
   */
  emptyField(nameField: string) {
    if (!this.form.controls[nameField].disabled) {
      this.form.controls[nameField].setValue('');
    }
  }

  /**
   * Controla los eventos de accion del seletor en modal
   *
   * @param {AccionModal} data
   * @memberof DynamicFormControlComponent
   */
  actionSelectModal(data: AccionModal) {
    this.actionSelector.emit(data);
  }

  /**
   * Ejecuta la funcion de salida del enfoque del campo
   *
   * @memberof DynamicFormControlComponent
   */
  focusOut() {
    if (isFunction(this.control.onFocusOut)) {
      this.control.onFocusOut(this.control.key);
    }
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/dynamic-form-control/dynamic-form-control.component.ts